<template>
  <form>
    <div>
      <button
        v-if="!newStory"
        class="button is-success mb-10"
        :class="{'is-loading': saving}"
        @click.prevent="saveStory"
      >
        Save changes
      </button>
    </div>
    <div>
      <div class="frow gutters mb-20">
        <div class="col-sm-1-2">
          <div class="field">
            <label
              class="label"
              for="name"
            >
              Title
            </label>
            <input
              id="title"
              v-model="story.title"
              class="input"
              name="title"
              type="text"
            >
          </div>
        </div>
        <div class="col-sm-1-2">
          <div class="frow gutters mb-20">
            <div class="col-sm-1-2">
              <div class="field">
                <label
                  class="label"
                  for="link"
                >
                  Story Link
                </label>
                <input
                  id="link"
                  v-model="story.link"
                  class="input"
                  name="link"
                  type="text"
                >
              </div>
            </div>
            <div class="col-sm-1-2">
              <div class="field">
                <label
                  class="label"
                  for="date"
                >
                  Date
                </label>
                <input
                  id="date"
                  v-model="story.date"
                  class="input"
                  name="date"
                  type="date"
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-1-2">
          <div class="field">
            <label
              class="checkbox reset frow mt-20 ml-10"
            >
              <div class="frow justify-start">
                <input
                  v-model="story.draft"
                  type="checkbox"
                >
                Draft
              </div>
            </label>
          </div>
        </div>
        <div class="col-sm-1-2">
          <div class="field">
            <label
              class="checkbox reset frow mt-20 ml-10"
            >
              <div class="frow justify-start">
                <input
                  v-model="story.isIntroStory"
                  type="checkbox"
                >
                intro story
              </div>
            </label>
          </div>  
        </div>
      </div>
    </div>
    <div class="field">
      <label
        class="label"
        for="description"
      >
        Description
      </label>
      <!-- <textarea
          v-model="story.description"
          class="textarea"
          id="description"
          name="description"
          style="height: 196px;"
      ></textarea> -->
      <wysiwyg
        ref="wysiwyg"
        v-model="story.description"
        class="wysiwyg"
      />
    </div>
    <LinkTool 
      :items="artWork" 
      name="art"
      @insertLink="insertLink"
    />
    <LinkTool 
      :items="stories" 
      name="story"
      @insertLink="insertLink"
    />
    <LinkTool 
      name="external"
      @insertLink="insertLink"
    />
    <ArtReferences
      :active-story="story"
      :art="artWork"
    />
    <!--
      <div
      class="card"
    >
      <header class="card-header">
        <p class="card-header-title">
          Description Preview:
        </p>
      </header>
      <div class="card-content">
        <div class="content">
          <div v-html="story.description" />
        </div>
      </div>
      </div> -->
    <button
      v-if="!newStory"
      class="button is-success is-pulled-right mt-20"
      :class="{'is-loading': saving}"
      @click.prevent="saveStory"
    >
      Save changes
    </button>
  </form>
</template>

<script>
import { mapState } from 'vuex';
import LinkTool from '@/components/LinkTool.vue';
import { parseUrlStrings } from '@/utils/parsing.js';
import ArtReferences from '@/components/ArtReferences';

export default {
  name: 'StoryForm',
  components: {
    LinkTool,
    ArtReferences,
  },
  props: {
    story: {
      type: Object,
      default: () => {},
    },
    newStory: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      saving: false,
      saveNewStory: false,
      linkTitle: '',
      artLinkTitle: '',
      stories: [],
      artWork: [],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.profile.user,
      jwt: (state) => state.profile.jwt,
    }),
    API() {
      return this.$API;
    },
  },
  created() {
    this.getStories();
    this.getArtWork();
  },
  methods: {
    insertLink(link) {
      // let cursorPosition = this.$refs.wysiwyg.selectionStart;
      // this.story.description = `${this.story.description.slice(0, cursorPosition)} ${link} ${this.story.description.slice(cursorPosition)}`;
      this.story.description = `${this.story.description} ${link} `;
    },
    saveStory() {
      const method = this.newStory ? 'POST' : 'PUT';
      const url = this.newStory ? `${this.$API}/stories/` : `${this.$API}/stories/${this.story.id}`;

      if (this.story.description) {
        this.story.description = parseUrlStrings(this.story.description);
      }
      const data = this.story;

      this.axios({
        method,
        headers: {
          Authorization: `Bearer ${this.jwt}`,
        },
        data,
        url,
      })
        .then((response) => {
          if (response.status === 200) {
            if (this.newStory) {
              this.story = response.data;
              this.saveNewStory = true;
            }
            this.$emit('closeModal');
            this.$snotify.success(`${this.story.title} saved`,'Success');
          }
        })
        .catch((err) => {
          console.log(err);
          this.$snotify.error(err, 'Saving failed', {
            timeout: 10000,
            showProgressBar: false,
          });
        });
    },
    getStories() {
      this.axios.get(`${this.$API}/stories?_sort=date:DESC&_limit=-1`).then((response) => {
        this.stories = response.data;
        [this.activeStory] = this.stories;
      });
    },
    getArtWork() {
      this.axios.get(`${this.$API}/arts?_limit=-1`).then((response) => {
        this.artWork = response.data.sort((a, b) => {
          let titleA = a.title.toUpperCase(); 
          let titleB = b.title.toUpperCase(); 
          if (titleA < titleB) {
            return -1;
          }
          if (titleA > titleB) {
            return 1;
          }
          return 0;
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
form {
  overflow-y: scroll;
  overflow-x: hidden;
  max-height: 700px;
}
label {
  text-align: left;
}
select {
  background-image: none;
}
.card {
  margin: 1px;
  // text-align: left;
}
img {
  max-height: 200px;
}
.wysiwyg {
  text-align: left;
}
</style>
